var map = {
	"./LTC.svg": 817,
	"./V-round.svg": 818,
	"./account-check.svg": 819,
	"./achievement.svg": 820,
	"./add.svg": 684,
	"./aim.svg": 821,
	"./alarm.svg": 822,
	"./allow.svg": 216,
	"./angle-double-left.svg": 405,
	"./angle-left.svg": 192,
	"./angle-right.svg": 259,
	"./anticheat-circle.svg": 823,
	"./antichit-warning.svg": 685,
	"./arrow-down.svg": 295,
	"./arrow-left.svg": 296,
	"./arrow-right.svg": 261,
	"./arrow-up-right.svg": 824,
	"./arrow-up.svg": 825,
	"./attention.svg": 406,
	"./auth_discord.svg": 826,
	"./auth_facebook.svg": 827,
	"./auth_google.svg": 828,
	"./auth_steam.svg": 829,
	"./auth_vk.svg": 830,
	"./berserk.svg": 831,
	"./blog.svg": 832,
	"./bona.svg": 833,
	"./bonusWarning.svg": 834,
	"./bookmark.svg": 835,
	"./calendar.svg": 343,
	"./call.svg": 407,
	"./cam-circle.svg": 686,
	"./cam.svg": 836,
	"./cells.svg": 837,
	"./chart-down.svg": 408,
	"./chart.svg": 838,
	"./chat.svg": 197,
	"./chatvvv.svg": 665,
	"./checkmark-blue.svg": 839,
	"./checkmark-double-green.svg": 687,
	"./checkmark-green-plain.svg": 661,
	"./checkmark-green.svg": 337,
	"./checkmark-red.svg": 840,
	"./checkmark-white.svg": 669,
	"./checkmark.svg": 409,
	"./close-red.svg": 688,
	"./close.svg": 169,
	"./coins-gold.svg": 297,
	"./coins-in-round.svg": 410,
	"./coins-new.svg": 689,
	"./coins-payout.svg": 411,
	"./coins-yellow.svg": 841,
	"./coins.svg": 257,
	"./colorpicker.svg": 842,
	"./combined.svg": 843,
	"./copy.svg": 662,
	"./cost.svg": 258,
	"./create.svg": 844,
	"./credit-card-sponsor.svg": 845,
	"./credit-card.svg": 298,
	"./crown.svg": 846,
	"./dashboard.svg": 847,
	"./denied.svg": 262,
	"./devices/android.svg": 412,
	"./devices/ios.svg": 413,
	"./devices/mac.svg": 414,
	"./devices/windows.svg": 415,
	"./diamond.svg": 416,
	"./discord.svg": 848,
	"./dislike.svg": 849,
	"./done-circle.svg": 690,
	"./dots.svg": 417,
	"./double-check.svg": 418,
	"./download.svg": 691,
	"./duration.svg": 850,
	"./earn.svg": 851,
	"./edit.svg": 666,
	"./email.svg": 852,
	"./enter.svg": 853,
	"./error.svg": 419,
	"./euro.svg": 338,
	"./exit.svg": 667,
	"./eye-closed.svg": 854,
	"./eye.svg": 855,
	"./facebook.svg": 856,
	"./filter-arrow.svg": 193,
	"./filter.svg": 857,
	"./fixed.svg": 692,
	"./flag.svg": 858,
	"./gamepad.svg": 670,
	"./gamepad2.svg": 859,
	"./gear.svg": 693,
	"./gem.svg": 860,
	"./gift.svg": 861,
	"./giftAuth.svg": 862,
	"./globe.svg": 694,
	"./google.svg": 695,
	"./halfstar.svg": 420,
	"./heart.svg": 332,
	"./hide.svg": 671,
	"./home.svg": 863,
	"./info.svg": 133,
	"./instagram.svg": 864,
	"./keyboard.svg": 672,
	"./kill.svg": 421,
	"./leaderboard.svg": 422,
	"./level.svg": 865,
	"./like.svg": 423,
	"./link-extra.svg": 424,
	"./link.svg": 217,
	"./list.svg": 866,
	"./location.svg": 867,
	"./lock-open.svg": 344,
	"./lock.svg": 339,
	"./mail-support.svg": 425,
	"./marketplace-delete.svg": 345,
	"./max-loses.svg": 868,
	"./menu.svg": 869,
	"./min-players.svg": 696,
	"./minus.svg": 870,
	"./money.svg": 871,
	"./money_2_sponsor.svg": 872,
	"./money_sponsor.svg": 873,
	"./my-account.svg": 874,
	"./new-rating.svg": 659,
	"./nominations.svg": 697,
	"./not-fixed.svg": 698,
	"./notifications.svg": 875,
	"./offerwall.svg": 876,
	"./other.svg": 877,
	"./overwolf.svg": 699,
	"./participants.svg": 700,
	"./paypal.svg": 878,
	"./pending.svg": 701,
	"./phone.svg": 879,
	"./player-empty.svg": 299,
	"./players.svg": 426,
	"./plus.svg": 260,
	"./prize.svg": 880,
	"./protect.svg": 881,
	"./qiwi.svg": 882,
	"./question-mark-white.svg": 265,
	"./question-mark-yellow.svg": 329,
	"./rating.svg": 883,
	"./readed-mail.svg": 427,
	"./referral.svg": 266,
	"./refresh.svg": 428,
	"./reglament.svg": 884,
	"./round-currencies/coins.svg": 702,
	"./round-currencies/money.svg": 703,
	"./round-currencies/tickets.svg": 704,
	"./ru-card.svg": 885,
	"./sad.svg": 335,
	"./santa-hat.svg": 429,
	"./sbp.svg": 886,
	"./search.svg": 887,
	"./security.svg": 888,
	"./send.svg": 889,
	"./settings.svg": 890,
	"./share.svg": 891,
	"./shield-user.svg": 892,
	"./shield.svg": 187,
	"./shop.svg": 430,
	"./shop_icon.svg": 893,
	"./sidebar.svg": 894,
	"./sign-in.svg": 404,
	"./smile-big.svg": 895,
	"./smile.svg": 896,
	"./star-gold.svg": 330,
	"./star-grey.svg": 664,
	"./star-round.svg": 897,
	"./star-small.svg": 898,
	"./star-v.svg": 899,
	"./star-violet.svg": 900,
	"./star-with-paddings.svg": 705,
	"./star.svg": 170,
	"./status.svg": 135,
	"./store.svg": 431,
	"./success.svg": 432,
	"./target.svg": 706,
	"./telegram.svg": 218,
	"./tetris.svg": 673,
	"./thunder.svg": 433,
	"./ticket-big.svg": 901,
	"./ticket.svg": 902,
	"./tiktok.svg": 903,
	"./time-schedule.svg": 904,
	"./time.svg": 668,
	"./timer.svg": 905,
	"./top_sponsor.svg": 906,
	"./trash.svg": 674,
	"./triangle.svg": 660,
	"./trophy.svg": 663,
	"./twitch.svg": 340,
	"./twitter.svg": 907,
	"./usd-card.svg": 908,
	"./user.svg": 300,
	"./v.svg": 334,
	"./verified.svg": 675,
	"./vk.svg": 909,
	"./wait.svg": 676,
	"./waiting.svg": 910,
	"./wallet-header.svg": 911,
	"./wallet.svg": 912,
	"./warning-2.svg": 913,
	"./warning.svg": 125,
	"./webmoney.svg": 914,
	"./world.svg": 707,
	"./x2.svg": 708,
	"./youtube.svg": 341
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78;